import { Alert } from "react-bootstrap";
import { useAlert } from "../context/AlertContext";

const GlobalAlert = () => {
  const { alert } = useAlert();

  if (!alert) return null;

  const getVariant = (type) => {
    if (type === "success") return "success";
    if (type === "error") return "danger";
    return "secondary"; // notice = grey
  };

  return (
    <div style={{ position: "fixed", bottom: "8%", left: "5%", zIndex: 9999 }}>
      <Alert variant={getVariant(alert.type)}>
        {alert.message}
      </Alert>
    </div>
  );
};

export default GlobalAlert;
